import { useMediaQuery } from 'react-responsive';
import { breakpoints } from './utils/breakpoints';

export const Mobile = ({ children }) => {
	const isMobile = useMediaQuery({ maxWidth: breakpoints.sm.max });
	return isMobile ? children : null;
};
